import React, { useEffect, useState, useCallback } from 'react';
import ReactPaginate from 'react-paginate';
import { Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faFileExcel} from '@fortawesome/free-solid-svg-icons';

  function PaginatedItems(props) {
    const data = props.data;
    //console.log(props.perpage+'__');
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemsPerPage, setitemsPerPage] = useState(3);
  
    useEffect(() => {
      console.log('1st UseEffect will triggered....'+props.perpage);
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(data.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);


    useEffect(() => {
      console.log('2nd UseEffect will triggered....'+props.perpage);
      setitemsPerPage(2);
    }, [2]);
    
    const handlePageClick = useCallback ((event) => {
      const newOffset = (event.selected * itemsPerPage) % data.length;
      setItemOffset(newOffset);
      console.log(newOffset);
    });
 
return (
<>
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-12">
  <div className="card admin-table">
    <div className="card-header">
    <h1>(30) EVENTS</h1>
    <Link to="/AddEventdetails" className="add-event">+ Add Event</Link>     
    </div>
    <div className="card-body">
        <div className="table-responsive">
    <table className="table">
    <thead>
        <tr>
            <th>Event</th>
            <th>Applicants</th>
            <th>Export</th>
            <th>Event Dates</th>
            <th> </th>
        </tr>
    </thead>
    <tbody>
    {
        
        currentItems.map( data => (
        <tr key={data.id}>
            <td>
            {data.event_name} <br/>
            {(() => {
                if(data.event_type==1){
                    return (
                        <>(Physical)</>
                    )
                }else{
                    return (
                        <>(Virtual Event)</>
                    )
                }
            })()}
            <br/>
            <Link to={ `/editeventdetails/${data.id}` }>Edit Details</Link><br/>
            <Link to="#">Upload Booths Map</Link><br/>
            <Link to="/programminglist">Fair Programming</Link>
            </td>            
            <td><Link to="/viewapplicants" >Applicants</Link></td>
            <td>
            <tbody className="ship">
            <tr>
            <td>
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Applicants</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Shipping / Load In</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Catalog Listing</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Social Media Content</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Programming</Link> 
            </td>
            <td>
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Guest List</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Badges</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Booth Extras</Link><br />
            <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Catalogue Images</Link><br />
            </td>
        </tr>
    </tbody>
</td>
<td>
<p><span>Start Date</span>: {data.start_date}</p>
<p><span>End Date</span>: {data.end_date}</p>
</td>
<td className="table-close">
<Link to="#"><FontAwesomeIcon icon={faXmark} /></Link>
</td>
</tr> 

))
}
</tbody>
</table> 


</div>
    </div>
    <div className="card-footer"><div className="pagination-title"><h3>Item #6</h3></div>
      <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="Previous"
            renderOnZeroPageCount={null}
            className="admin-paginate"
      />
    </div>
</div>
</div>
</div>
</div>  
</section>
        
      </>
    );
  }

  export default PaginatedItems;